// This file is included on every page

var ariaNavi = 'navigation ';
var ariaSubNavi = 'subnavigation';
var ariaOpen = 'open';
var ariaClose = 'close';


if ($('html').is(':lang(fi)')) {
    ariaNavi = 'valikko ';
    ariaSubNavi = 'sivuvalikko';
    ariaOpen = 'avaa';
    ariaClose = 'sulje';
    
} else if ($('html').is(':lang(en)')) {
    ariaNavi = 'navigation';
    ariaSubNavi = 'subnavigation';
    ariaOpen = 'open';
    ariaClose = 'close';
    
} else if ($('html').is(':lang(sv)')) {
    ariaNavi = 'menu';
    ariaSubNavi = 'undermenu';
    ariaOpen = 'öppna';
    ariaClose = 'stäng';
    
}

$(() => {
    initShareButtons();
    ResponsifyTables();
})

// Make all the tables on the site responsive
function ResponsifyTables() {
    $('table').wrap("<div class='table-responsive'></div>");
}

//share buttons
function initShareButtons() {
    $('a.share').each(function () {
        $(this).on('click', function (event) {
            event.preventDefault();
            var options = {
                url: $(this).attr('data-share-url'),
                height: $(this).attr('data-share-height'),
                width: $(this).attr('data-share-width'),
                snbPagename: $(this).attr('data-snb-pagename'),
                snbSection: $(this).attr('data-snb-section')
            }
            if (options.height === undefined) options.height = 570;
            if (options.width === undefined) options.width = 520;

            window.open(options.url + encodeURIComponent(location.href), 'ShareDialog', 'width=' + options.width + ',height=' + options.height);
        });
    });
}

/*global $ */
var sysUIbreak = 1099, Fvheader, Fvtopheader, Fvsticky;


$(document).ready(function () {
    
    $(".second-level-frame").on('focusout', function (event) {
        if (!$(event.relatedTarget).closest('.second-level-frame').length && !$(event.relatedTarget).is('.first-level-toggle') && !$(event.originalEvent.target).is('button.mobile-close-btn')) {
            $(this).removeClass('open-menu').fadeOut();
            $(this).siblings('.first-level-toggle').removeClass('open').attr('aria-expanded', 'false');
        }
    });

    $.fn.menuHeight = function (e) {
        let originalHeight = 0;
        let submenuHeight = 0;
        let topMenu = $(this).closest('.second-level-frame');
        if ($(this).hasClass('first-level-toggle')) {
            topMenu = $(this).siblings('.second-level-frame');
        }
        originalHeight = $(topMenu).innerHeight();
        $(topMenu).find('.open-menu').each(function () {
                $(this).css({
                    'visibility': 'hidden',
                    //'display': 'block'
                });
                //console.log("open height: " + $(this).outerHeight());
                if ($(this).outerHeight() > submenuHeight) {
                    submenuHeight = $(this).outerHeight();
                    //console.log("submenu height: " + submenuHeight);
                }
                $(this).css({
                    'visibility': 'inherit',
                });
            });

        if (submenuHeight === 0) {
            $(topMenu).css('height', 'auto');
        } else {
            $(topMenu).css('height', submenuHeight + 120);
        }
    }

    
    // If the target of the click isn't the container
    $(document).mouseup(function (e) {
        var container = $("#topmenu");

        // If the target of the click isn't the container
        if (!container.is(e.target) && container.has(e.target).length === 0 && $(window).width() > 1099) {
            $('.first-level-toggle').removeClass("open").attr('aria-expanded', 'false');
            $('.first-level-toggle').siblings('a').removeClass('open');
            $(container).find('.second-level-frame').fadeOut().removeClass('open-menu');

            
        }

        var searchContainer = $('#header-top-row');
        if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0) {
            $('#header-search-form').slideUp();
            $('#open-search').attr('aria-expanded', 'false');
        }
    });

    
    $(".menu .toggle").on('click', function (e) {
       
        $(this).parentsUntil('.frame').siblings().find('.toggle').removeClass('open');
        $(this).parentsUntil('.frame').siblings().find('a').removeClass('open');
        $(this).parentsUntil('.frame').siblings().find('.toggle').attr('aria-expanded', 'false');
        $(this).parentsUntil('.frame').siblings().find('.frame').fadeOut(); 
        if (!$(this).hasClass('open')) {
            $(this).attr('aria-expanded', 'true');
            $(this).addClass('open');
            $(this).siblings('a').addClass('open');
            $(this).siblings('.frame').fadeIn().addClass('open-menu');
            
            if ($(this).siblings().hasClass('second-level-frame')) {
                $(this).siblings('.second-level-frame').children('ul').addClass('open-menu');
            }
            if ($(window).width() < 1100) {
                $(this).parent('.link-frame').closest('.frame').scrollTop(0);
                $(this).parent('.link-frame').closest('.frame').css('overflow-y', 'hidden');
                $(this).siblings('.frame').css('overflow-y', 'auto');
                $(this).siblings('.frame').scrollTop(0);
            }

            $(this).menuHeight(e);
        } else {
            $(this).attr('aria-expanded', 'false');
            $(this).removeClass('open');
            $(this).siblings('a').removeClass('open');
            $(this).siblings('.frame').fadeOut().removeClass('open-menu');
            if ($(this).siblings().hasClass('second-level-frame')) {
                $(this).siblings('.second-level-frame').children('ul').removeClass('open-menu');
            }
            if ($(window).width() < 1100) {
                $(this).parent('.link-frame').closest('frame').css('overflow-y', 'inherit');
                $(this).siblings('.frame').css('overflow-y', 'inherit');
            }
            $(this).menuHeight(e);
        }
        /*
        var menuHeight = $('.second-level-frame').innerHeight();
        console.log('Menu ' + menuHeight);
        

        var submenuHeight = 0;
        $(this).parents('.first-level').find('.open-menu').each(function () {
            console.log('open height ' + $(this).height());
            if ($(this).height() > submenuHeight) {
                submenuHeight = $(this).outerHeight();
                console.log("height " + submenuHeight);
                
            } 

        });

        if (submenuHeight === 0) {
            $('.second-level-frame').css('height', 'auto');
        } else {
            $('.second-level-frame').css('height', submenuHeight + 40);
        }
        */
    });

    $('.menu-mobile').on('click', function () {
        if ($(this).attr('aria-expanded') === 'false') {
            $('.menu-container').slideDown();
            $(this).addClass('open-mobile');
            $(this).attr('aria-expanded', 'true');
            $('body').css('overflow-y', 'hidden');
        } else {
            $('.menu-container').slideUp();
            $(this).removeClass('open-mobile');
            $(this).attr('aria-expanded', 'false');
            $('body').css('overflow-y', 'scroll')
        }
    });

    $('.mobile-close-btn').on('click', function (e) {
        //console.log(e);
        $(this).parent('.mobile-close').parent('.frame').siblings('.toggle').removeClass('open').attr('aria-expanded', 'false');
        $(this).parent('.mobile-close').parent('.frame').parent('.link-frame').parent('li').parent('.frame').css('overflow-y', 'auto');
        $(this).parent('.mobile-close').parent('ul:not(.second-level)').fadeOut();

        if ($(this).parent('.mobile-close').parent('ul').hasClass('second-level')) {
            $(this).closest('.second-level-frame').fadeOut();
            $(this).closest('.second-level-frame').siblings('.toggle').removeClass('open').attr('aria-expanded', 'false');
        }
        
    });

    
});



// stickheader II
window.onscroll = function () { stickheader(); };

Fvheader = document.getElementById("topmenu");
Fvtopheader = document.getElementById("header-top-row");
var Fvsticky = 0;

//check if main menu exists
if (Fvheader != null) {
    Fvsticky = Fvheader.offsetTop;
}

function stickheader() {
    if ($(window).width() > sysUIbreak) {
        if (window.pageYOffset > Fvsticky) {
            //console.log(window.pageYOffset);
            $("#sticky-menu").addClass('sticky2');
            $("#header-top-row").addClass('sticky');
            //Fvheader.classList.add("sticky2");
            //Fvtopheader.classList.add("sticky");
        } else {
            //Fvheader.classList.remove("sticky2");
            //Fvtopheader.classList.remove("sticky");
            $("#sticky-menu").removeClass('sticky2');
            $("#header-top-row").removeClass('sticky');
        }
    }
    /**/
    else {
        if (window.pageYOffset >= Fvsticky) {
            $('.icon-up').show();
        } else {
            $('.icon-up').hide();
        }
    } /**/
}







    //$('*').on('focus blur keyup', function (event) { console.log(event.type + " to:"); console.log(document.activeElement); })

    $(".menu .mobileopenbox ").click(function (e) {
        if ($(window).width() <= sysUIbreak) {
            $(this).parent().toggleClass('togled');
            if ($(this).siblings().hasClass('menu-wrapper')) {
                //console.log('test');
                if ($(this).parent().hasClass('togled')) {
                    $(this).siblings('.menu-wrapper').children('a').attr('aria-expanded', true);
                } else {
                    $(this).siblings('.menu-wrapper').children('a').attr('aria-expanded', false);
                }
            } else {
                if ($(this).parent().hasClass('togled')) {
                    $(this).prev().prev('a').attr('aria-expanded', true);
                } else {
                    $(this).prev().prev('a').attr('aria-expanded', false);
                }
            }

            
            
            //	$(this).parent().siblings('li').removeClass('togled');
            /*
            $(this).parent().siblings('li').each(function (index, value) {
                $(this).removeClass('togled');
                $(this).find('.togled').removeClass('togled');
                $
            });*/
            e.preventDefault();
        }
    });

/*
    $(".menu-mobile").click(function (e) {
        $(".identity-area.toke").toggleClass("hide-on-mobile");
        $(".menu > ul").toggleClass('show-on-mobile');
        $(".menu > #header-top-row-mobile-main").toggleClass('show-on-mobile');
        $(".menu > #header-top-row-mobile").toggleClass('show-on-mobile');
        $(".menu > #header-links-mobile").toggleClass('show-on-mobile');
        $(".menu > #header-search-form-mobile").toggleClass('show-on-mobile');
        if ($(".show-on-mobile").length > 0) {
            $(this).addClass('menu-mobile-open');
            //added 26.02.2020
            $(this).prop("title", ariaClose + " " + ariaNavi);
            $(this).attr("aria-label", ariaClose + " " + ariaNavi);
        } else {
            $(this).removeClass('menu-mobile-open');
            //added 26.02.2020
            $(this).prop("title", ariaOpen + " " + ariaNavi);
            $(this).attr("aria-label", ariaOpen + " " + ariaNavi);
        }
        if ($(this).attr('aria-expanded') === 'false') {
            $(this).attr('aria-expanded', true);
        } else {
            $(this).attr('aria-expanded', false);
        }
        e.preventDefault();
    });*/

    //preval mobile
    if ($(".menu > ul .current").length > 0) {
        $(".menu > ul .current").parent().addClass('xActive');
        $(".menu > ul .xActive").addClass('togled');
    }

    if ($(window).width() < 1100) {
        $('.togled').children('a').attr('aria-expanded', true);
        $('.togled').children('.menu-wrapper').children('a').attr('aria-expanded', true);
    }

    $(window).resize(function () {
        if ($(window).width() >= 1100) {
            $('.menu > ul > li >ul >li:has( > ul)').children('a').removeAttr('aria-expanded');
            $('.menu > ul > li >ul >li >ul >li:has( > ul)').children('a').removeAttr('aria-expanded');
            $('body').css('overflow-y', 'scroll');
            $('.menu-container.container').css('display', 'flex');
            $('.frame').css('overflow-y', 'inherit');
        } else {
            if ($('.menu .has-children').parent('li').hasClass('togled')) {
                $(this).children('a').attr('aria-expanded', true);
            } else {
                $(this).children('a').attr('aria-expanded', false);
            }
            if ($('.menu > ul > li >ul >li:has( > ul)').hasClass('togled')) {
                $('.menu > ul > li >ul >li:has( > ul)').children('a').attr('aria-expanded', true);
            } else {
                $('.menu > ul > li >ul >li:has( > ul)').children('a').attr('aria-expanded', false);
            }
            if ($('.menu > ul > li >ul >li >ul >li:has( > ul)').hasClass('togled')) {
                $('.menu > ul > li >ul >li >ul >li:has( > ul)').children('a').attr('aria-expanded', true);
            } else {
                $('.menu > ul > li >ul >li >ul >li:has( > ul)').children('a').attr('aria-expanded', false);
            }
        }
    });

    //desktop-bg
    $(' .menu > ul > li > ul ').each(function (index, value) {
        var intTmpcount = $(this).children('li').length;
        if (intTmpcount == 1) { $(this).addClass('bg30'); }
        if (intTmpcount == 2) { $(this).addClass('bg50'); }
    });

    

    // TabsBlock aria-selected
    $('div.block.tabsblock > ul.nav-tabs a').on('click', function (e) {
        $(this).attr('aria-selected', true);
        $(this).parent().siblings('li').children('a').attr('aria-selected', false);
    })

    /*
    $('.nav-tabs > li > a').focus(function () {
        $(this).keyup(function (e) {
            if (e.which == 39) {
                e.preventDefault();
                $(this).parent().next().tab('show');
                $(this).attr('aria-selected', false);
                $(this).parent().next().find('a').attr('aria-selected', true);
                $(this).parent().next().find('a').focus();
            } else if (e.which == 37) {
                e.preventDefault();
                $(this).parent().prev().tab('show');
                $(this).attr('aria-selected', false);
                $(this).parent().prev().find('a').attr('aria-selected', true);
                $(this).parent().prev().find('a').focus();
            }
        });
    });
    */
/*
});*/

/*  cookies*/

function checkCookieConsent() {
    //remove cookie consent notice if cookie is set
    if (document.cookie.match('cookie-consent')) {
        $('#cookie-consent').remove();
    } else {
        $("#cookie-consent button").click(function () {
            consentToCookieUse();
        });

        $('#cookie-consent').removeClass('hide');
    }
}

function consentToCookieUse() {
    // accept cookies
    document.cookie = "cookie-consent=true; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    $("#cookie-consent").remove();
}

$(document).ready(function () {
    checkCookieConsent();
});

/*end  cookies*/

$(document).ready(function () {
    /*LeftNav*/
    var Nvobj = $("#LeftNavi a.active");
    if (Nvobj.length == 1) {
        Nvobj.parents('li').addClass('openlevel');
    }

    $(document).ready(function () {
        $('#LeftNavi .haschildren > a').after("<button class='arrow'><span class='open'>+</span><span class='close'>–</span></button>");
        $('#LeftNavi .haschildren > .arrow').attr('aria-expanded', false);
        $('#LeftNavi .openlevel > .arrow').attr('aria-expanded', true);

        $('#LeftNavi button.arrow').click(function () {
            $(this).parent().children('ul').slideToggle();
            $(this).parent().toggleClass('openlevel');
            if ($(this).parent().hasClass('openlevel')) {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }
        });

        $('#LeftNavi .haschildren > a').keydown(function (e) {
            if (e.which === 32) {
                e.preventDefault();
                $(this).parent().children('ul').slideToggle();
                $(this).parent().toggleClass('openlevel');
                if ($(this).parent().hasClass('openlevel')) {
                    $(this).parent().children('a').attr('aria-expanded', true);
                } else {
                    $(this).parent().children('a').attr('aria-expanded', false);
                }
            } else if (e.which === 40) {
                e.preventDefault();
                $(this).parent().children('ul').slideDown();
                $(this).parent().addClass('openlevel');
                $(this).parent().children('a').attr('aria-expanded', true);
            } else if (e.which === 38) {
                e.preventDefault();
                $(this).parent().children('ul').slideUp();
                $(this).parent().removeClass('openlevel');
                $(this).parent().children('a').attr('aria-expanded', false);
            }
        });
    });

    $('#sideNaviMobile .haschildren > a').after("<button class='arrow'><span class='open'>+</span><span class='close'>–</span></button>");
    $('#sideNaviMobile .haschildren > a').attr('aria-expanded', false);
    $('#sideNaviMobile .openlevel > a').attr('aria-expanded', true);

    $('#sideNaviMobile button.arrow').click(function () {
        $(this).parent().children('ul').slideToggle();
        $(this).parent().toggleClass('openlevel');
        if ($(this).parent().hasClass('openlevel')) {
            $(this).parent().children('a').attr('aria-expanded', true);
        } else {
            $(this).parent().children('a').attr('aria-expanded', false);
        }
    });

    $('#sideNaviMobile .haschildren > a').keydown(function (e) {
        if (e.which === 32) {
            e.preventDefault();
            $(this).parent().children('ul').slideToggle();
            $(this).parent().toggleClass('openlevel');
            if ($(this).parent().hasClass('openlevel')) {
                $(this).parent().children('a').attr('aria-expanded', true);
            } else {
                $(this).parent().children('a').attr('aria-expanded', false);
            }
        } else if (e.which === 40) {
            e.preventDefault();
            $(this).parent().children('ul').slideDown();
            $(this).parent().addClass('openlevel');
            $(this).parent().children('a').attr('aria-expanded', true);
        } else if (e.which === 38) {
            e.preventDefault();
            $(this).parent().children('ul').slideUp();
            $(this).parent().removeClass('openlevel');
            $(this).parent().children('a').attr('aria-expanded', false);
        }
    });

    $(document).ready(function () {
        $('#mobileNaviBtn').click(function () {
            $('#sideNaviMobile').slideToggle();
            $('#mobileNaviBtn .chevron').toggleClass('invert');

            if ($("#btnSubmenu-mobile")[0].classList.contains("menu-mobile-open")) {
                $("#btnSubmenu-mobile").removeClass('menu-mobile-open');
                $('#mobileNaviBtn').attr('aria-expanded', false);
                $('#mobileNaviBtn').attr('aria-label', ariaOpen + " " + ariaSubNavi);
            } else {
                $("#btnSubmenu-mobile").addClass('menu-mobile-open');
                $('#mobileNaviBtn').attr('aria-expanded', true);
                $('#mobileNaviBtn').attr('aria-label', ariaClose + " " + ariaSubNavi);
            }

        });
    });
    /*end  LeftNav*/
    /*
    $("#header-top-row #header-search #quick-search-query").focus(function () {
        $("#header-top-row #header-search #quick-search-query").animate({ width: "180px" }, 700);
        $("#header-top-row #header-search .input-group ").animate({ width: "224px" }, 600);
    });
    $("#header-top-row #header-search #quick-search-query").blur(function () {
        $("#header-top-row #header-search #quick-search-query").animate({ width: "65px" }, 700);
        $("#header-top-row #header-search .input-group ").animate({ width: "120px" }, 600);
    });*/

    $('.container.contentpageclass').each(function (index, value) {
        if ($(this).find('.LeftNaviContainer').length == 0)
            $(this).addClass('hasnoleftmenu');
    });

    /* Search button */
    $('#open-search').on('click', function () {
        $('#header-search-form').slideToggle();
        if ($("#open-search").attr("aria-expanded") === "false") {
            $("#open-search").attr("aria-expanded", "true");
            //$('html body').css('overflow-y', 'hidden');
            $('#quick-search-query').focus();
        } else {
            $("#open-search").attr("aria-expanded", "false");
            //$('html body').css('overflow-y', 'auto');
        }
        if ($("#close-search").attr("aria-expanded") === "false") {
            $("#close-search").attr("aria-expanded", "true");
        } else {
            $("#close-search").attr("aria-expanded", "false");
        }
    });

    $('#close-search').on('click', function (e) {
        e.preventDefault();
        $('#header-search-form').fadeOut();
        $("#close-search").attr("aria-expanded", "false");
        $("#open-search").attr("aria-expanded", "false");
        $('html body').css('overflow-y', 'auto');
    });

    $(document).on("keyup", function (e) {
        
        if ($("#open-search").attr("aria-expanded") === "true" && e.keyCode === 27) {
            $('#header-search-form').fadeOut();
            $("#close-search").attr("aria-expanded", "false");
            $("#open-search").attr("aria-expanded", "false");
            $('html body').css('overflow-y', 'auto');
        }

        if (e.keyCode === 27) {
            $('.first-level-toggle').each(function () {
                $(this).removeClass('open').attr('aria-expanded', 'false');
                $(this).siblings('.second-level-frame').removeClass('open-menu').fadeOut();
            });
        }
    })

    /*searcpage*/
    $('.searchboxform>.input-group >span>a').addClass('btn btn-rectangle');

    $('body').append('<span class= "icon-up" ></span >');
    $('.icon-up').click(function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'fast');
        $('.icon-up').hide();
    });

    $('.openvacanciesblock .utils>a').addClass('btn btn-rectangle');
});

$(window).resize(function () {
    $('.icon-up').hide();
});

$(function () {
    $("#skipcontent").on("click", function (e) {
        e.preventDefault();
        const target = $(this).attr("href");

        if (target.length) {
            $(target).focus();
            const targetPosition = $(target).offset().top - 400;

            $('html, body').animate({
                scrollTop: targetPosition
            }, 0); 

            
        }
    });
});